import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../constance";

const AddProduct = () => {
  const [title, setTitle] = useState("");
  const [price, setPrice] = useState("");
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [image, setImage] = useState("");
  const [pLink, setPLink] = useState("");
  const [errors, setErrors] = useState({});

  const handleImageUpload = (images) => {
    setLoading(true);
    const data = new FormData();
    data.append("file", images);
    data.append("upload_preset", "nature_power");
    data.append("cloud_name", "akshaydholakiya");
    fetch(`https://api.cloudinary.com/v1_1/akshaydholakiya/image/upload`, {
      method: "POST",
      body: data,
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(true);
        setImage(data?.url);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (id) {
      setLoading(false);
      axios
        .get(`/products/` + id)
        .then((res) => {
          setTitle(res?.data?.title);
          setPrice(res?.data?.price);
          setImage(res?.data?.photo);
          setPLink(res?.data?.link);
          setLoading(false);
        })
        .catch((error) => {
          console.error("There was an error adding the product:", error);
          setLoading(false);
        });
    }
  }, [id]);

  const validate = () => {
    let errors = {};
    if (title === "") {
      errors.title = "Title is required";
    }
    if (price === "") {
      errors.price = "Price is required";
    } else if (isNaN(price) || price <= 0) {
      errors.price = "Price must be a positive number";
    }
    if (!image) {
      errors.image = "Image is required";
    }
    if (!pLink) {
      errors.link = "Link is required";
    }
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validate();
    if (Object.keys(errors).length === 0) {
      setLoading(true);

      const productData = {
        title,
        price,
        photo: image,
        link: pLink,
      };
      if (id) {
        axios
          .put(`/products/${id}`, productData)
          .then((res) => {
            navigate("/admin/products");
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      } else {
        axios
          .post(`/products`, productData)
          .then((res) => {
            navigate("/admin/products");
            setLoading(false);
          })
          .catch((error) => {
            console.error("There was an error adding the product:", error);
            setLoading(false);
          });
      }
    } else {
      setErrors(errors);
    }
  };

  return (
    <div className="container mx-auto mt-36 min-h-screen">
      {loading && <Loader loading={loading} />}
      <div className="flex flex-row gap-4 items-center mt-10">
        <h2 className="text-primary text-[25px] font-semibold">Add Products</h2>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="border mt-10 p-5 rounded-md">
          <div className="md:flex flex-row justify-between gap-5 items-center mb-5">
            <div className="md:w-1/2">
              <label className="text-sm text-primary">Product Name*</label>
              <input
                type="text"
                placeholder="Product Name"
                name="product_name"
                className="w-full border px-2 h-[40px] rounded-md text-sm"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              {errors.title && (
                <div className="text-red-500 mt-2">{errors.title}</div>
              )}
            </div>
            <div className="md:w-1/2 my-5 md:my-0">
              <label className="text-sm text-primary">Price*</label>
              <input
                type="number"
                placeholder="€ Enter Price"
                name="price"
                className="w-full border px-2 h-[40px] rounded-md text-sm"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
              {errors.price && (
                <div className="text-red-500 mt-2">{errors.price}</div>
              )}
            </div>
            <div className="w-full">
              <label className="text-sm text-primary">link*</label>
              <input
                type="text"
                placeholder="Enter Product Link"
                name="link"
                className="w-full border px-2 h-[40px] rounded-md text-sm"
                value={pLink}
                onChange={(e) => setPLink(e.target.value)}
              />
              {errors.link && (
                <div className="text-red-500 mt-2">{errors.link}</div>
              )}
            </div>
          </div>
          <label className="text-sm text-primary ">Add Image*</label>
          <div className="border-dashed rounded-md border-2 p-4 mt-2">
            <div className="flex flex-col justify-center items-center mx-auto mt-5">
              {image && !loading ? (
                <div className="relative ">
                  <img
                    src={image}
                    alt="Uploaded Image"
                    className="w-full h-32 md:h-48 object-contain"
                  />
                  <MdDelete
                    onClick={() => setImage(!image)}
                    className="absolute right-0 z-40 top-0 bg-gray-300  text-3xl text-red-600 p-2 rounded-full"
                  />
                </div>
              ) : (
                <>
                  <div className="flex justify-center items-center mx-auto text-center">
                    <input
                      type="file"
                      onChange={(e) => {
                        setImage(e.target.files[0]);
                        handleImageUpload(e.target.files[0]);
                      }}
                    />
                  </div>
                  <p className="text-lg text-gray-500 my-2  ">or</p>
                  <p className="text-sm text-gray-500 mb-10 capitalize">
                    drag and drop here
                  </p>
                </>
              )}
            </div>
          </div>
          {errors.image && (
            <div className="text-red-500 mt-2">{errors.image}</div>
          )}
          <div className="flex justify-end mt-5">
            <button
              type="submit"
              className="bg-blue-500 text-white py-2 px-4 rounded-md"
            >
              {id ? "Update" : "Submit"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
export default AddProduct;
